export const PDF_COLOURS = [
  { id: 'ink', label: 'Ink', text: 'text-ink', background: 'bg-ink' },
  { id: 'sky', label: 'Sky', text: 'text-brand-sky', background: 'bg-brand-sky' },
  { id: 'coral', label: 'Coral', text: 'text-brand-coral', background: 'bg-brand-coral' },
  { id: 'mint', label: 'Mint', text: 'text-brand-mint', background: 'bg-brand-mint' },
  { id: 'yellow', label: 'Yellow', text: 'text-brand-sunshine', background: 'bg-brand-sunshine' },
] as const;

export type PdfColour = (typeof PDF_COLOURS)[number]['id'];
export type PdfTool = 'read' | 'ink' | 'highlight' | 'note' | 'erase';
export type PdfPoint = { x: number; y: number };
export type PdfDraft =
  | { kind: 'ink'; points: PdfPoint[]; colour: PdfColour; width: number }
  | { kind: 'highlight'; start: PdfPoint; end: PdfPoint; colour: PdfColour }
  | null;

export const PDF_PEN_WIDTHS = [
  { label: 'Fine', value: 0.002 },
  { label: 'Medium', value: 0.004 },
  { label: 'Bold', value: 0.008 },
] as const;

export function pdfColour(value: unknown) {
  return PDF_COLOURS.find((colour) => colour.id === value) ?? PDF_COLOURS[2];
}
